import AbstractMapper from './AbstractMapper'

class SelectMapper extends AbstractMapper {
  azienda () {
    return new this.select('aziende', 'id', 'ragsoc', true)
  }

  ambito () {
    return new this.select('ambiti', 'ambito', 'descrizione', true)
  }

  categoria () {
    return new this.select('categoria', 'idcat', 'dex', true)
  }

  tipoDoc (filterBy) {
    let api = null
    switch (filterBy) {
      case 'ambito':
        api = `tipo_doc/${filterBy}/{ambito}`
        break
      default:
        api = 'tipo_doc'
    }
    return new this.select(api, 'id', 'tipdoc', true)
  }

  tipoVoce () {
    return new this.select('tipo_voce', 'tipo_voce', 'dex', true)
  }

  tipoRec () {
    return new this.select('tiprec', 'tiprec', 'dex', true)
  }

  tipoDipendente () {
    return new this.select('tipo_dipendenti', 'tipo', 'dex', true)
  }

  tipoScadenze () {
    return new this.select('tipo_scadenza', 'id', 'tiposca', true)
  }

  tipoNomina (filterBy) {
    let api = null
    switch (filterBy) {
      case 'ambito':
        api = `tipo_nomine/${filterBy}/{ambito}`
        break
      default:
        api = 'tipo_nomine'
    }
    return new this.select(api, 'id', 'tiponomina', true)
  }

  tipoSegnalazione () {
    return new this.select('tipo_segnalazione', 'id', 'dex', true)
  }

  collaboratore (filterBy) {
    let api = null
    switch (filterBy) {
      case 'aziende':
        api = `collaboratori/${filterBy}/{idazi}`
        break
      default:
        api = 'collaboratori'
    }
    return new this.select(api, 'id', 'nome', true)
  }

  dipendente (filterBy) {
    let api = null
    switch (filterBy) {
      case 'aziende':
        api = `dipendenti/${filterBy}/{idazi}`
        break
      default:
        api = 'dipendenti'
    }
    return new this.select(api, 'id', ['nome', 'cognome'], true)
  }

  referenziamento () {
    return new this.select(null, 'value', 'label', false)
  }

  fornitori (filterBy) {
    let api = null
    switch (filterBy) {
      case 'aziende':
        api = `fornitori/${filterBy}/{idazi}`
        break
      default:
        api = 'fornitori'
    }
    return new this.select(api, 'id', 'ragsoc', true)
  }

  daysOfWeek () {
    return new this.select(null, 'value', 'label', false)
  }

  ricorrenza () {
    return new this.select(null, 'value', 'label', false)
  }
}

export default new SelectMapper()
